
import { Component, Vue } from 'vue-property-decorator';

import Form22ProcessHeader from "@/components/process/Form22/components/Form22ProcessHeader.vue";
import { form22StatusInfoType } from '@/types/Information/Form22';

@Component({
    components:{
        Form22ProcessHeader
    }
})
export default class CancelSubmitForm22 extends Vue {

    stepsCompleted = {} as form22StatusInfoType;  
    mountedData = false;     

    mounted() {

        this.mountedData = false;        

        this.stepsCompleted = {
            first: true,
            second: true,
            third: false
        }
        this.mountedData = true;                   
    }    

    public done() {
        this.$router.push({name: "dashboard" }) 
    }
}
